import type { SVGProps } from 'react';

const SvgFormatTextdirectionRToL = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4m-2 7v-3l-4 4 4 4v-3h12v-2z" />
  </svg>
);
export default SvgFormatTextdirectionRToL;
